<ca-element-loader [loading]="loading" [translucent]="true">
  @if (categories) {
    <mat-chip-listbox class="relationships" multiple>
      @for (category of categories; track category) {
        @if (category.animationId) {
          <ca-animated-category
            [category]="category"
            [selected]="_selected | arrayIncludes: category.id"
            (toggleEvent)="toggle(category.id)"
          ></ca-animated-category>
        } @else {
          <mat-basic-chip-option
            [value]="category.id"
            [selected]="_selected | arrayIncludes: category.id"
            [class.selected]="_selected | arrayIncludes: category.id"
            (click)="toggle(category.id)"
            color="secondary"
          >
            <ca-badge class="transparent" [name]="category.icon"></ca-badge>
            {{ category.name }}
          </mat-basic-chip-option>
        }
      }
    </mat-chip-listbox>
  }
</ca-element-loader>
